import { useEffect, useMemo, useRef, useState } from 'react';

const PINBALL_ENTRY = '/games/pinball/index.html';

export const PinballApp = () => {
  const frameRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const src = useMemo(() => `${PINBALL_ENTRY}?t=${Date.now()}`, []);

  const focusGame = () => {
    const frame = frameRef.current;
    if (!frame) return;

    frame.focus();
    try {
      frame.contentWindow?.focus();
    } catch {
      // Cross-origin focus read can fail; local pinball build should be same-origin.
    }
  };

  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return;

    const handleLoad = () => {
      setIsLoaded(true);
      focusGame();
    };

    frame.addEventListener('load', handleLoad);
    return () => frame.removeEventListener('load', handleLoad);
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background: '#101820',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
      onMouseDown={focusGame}
    >
      {!isLoaded && (
        <div
          style={{
            position: 'absolute',
            zIndex: 2,
            fontFamily: 'Tahoma, Verdana, Arial, sans-serif',
            fontSize: 12,
            color: '#D8E4F5',
            background: 'rgba(0, 0, 0, 0.55)',
            border: '1px solid #4A5E86',
            padding: '6px 10px',
          }}
        >
          Loading 3D Pinball...
        </div>
      )}

      <div
        style={{
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
          aspectRatio: '2 / 3',
          boxShadow: '0 0 0 1px #2A3B54, 0 0 12px rgba(0, 0, 0, 0.6)',
          background: '#000',
        }}
      >
        <iframe
          ref={frameRef}
          title="3D Pinball"
          src={src}
          tabIndex={0}
          allow="autoplay; fullscreen; gamepad"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block',
            background: '#000',
          }}
        />
      </div>
    </div>
  );
};

export default PinballApp;
